/* eslint-disable */
import React from 'react';
import { useHistory } from 'react-router-dom';
import './DashboardSection.css';
import NewInfoIcon from '../ProcureToPayComp/TileComp/NewInfoIcon';

const DashboardSection = ({
  title,
  children,
  showDetailView = true,
  disableDetailView = false,
  detailPath,
  detailState = {} ,
  infoIcondata = "",
}) => {
  const history = useHistory();

  const handleDetailClick = () => {
    if (detailPath) {
      history.push(detailPath, detailState);
    }
  };

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-header">
        <h3>{title}</h3>
        <div className='d-flex justify-content-center align-items-center'>
          {showDetailView && !disableDetailView && (
            <button
              className="detail-view-btn"
              onClick={handleDetailClick}
            >
              Detailed View <span className="arrow">»</span>
            </button>
          )}


            {infoIcondata &&
              <div className='ml-2' style={{ position: "relative", overflow: "visible", zIndex: 50, }}>
                <NewInfoIcon popupContent={infoIcondata} />
              </div>
            }
        </div>

      </div>
      <div className="dashboard-section-body">
        {children}
      </div>
    </div>
  );
};

export default DashboardSection;


